import React, { useState } from "react";
import styles from "./chat-input.module.css";

const ChatInput = ({ onSend }) => {
  const [input, setInput] = useState("");

  const handleOnSend = () => {
    if (input) {
      onSend(input);
      setInput("");
    }
  };

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      handleOnSend();
    }
  };

  return (
    <div className={styles.container}>
      <input
        type="text"
        value={input}
        onInput={(e) => setInput(e.target.value)}
        placeholder="Ask your question here"
        className={styles.input}
        onKeyDown={handleEnter}
      />
      <button className={styles.button} onClick={handleOnSend}>
        SEND
      </button>
    </div>
  );
};

export { ChatInput };
